module.exports = __webpack_public_path__ + "img/hover-imgs-item-3.bf8ee233.png";